import { ImageLibraryOptions, CameraOptions, PhotoQuality } from 'react-native-image-picker'

const MAX_SIZE = 1280
const QUALITY: PhotoQuality = 0.9

const qualityOptions = {
  maxHeight: MAX_SIZE,
  maxWidth: MAX_SIZE,
  quality: QUALITY,
}

const cameraOptions: CameraOptions = {
  ...qualityOptions,
  mediaType: 'photo',
  includeBase64: true,
}

const libraryOptions: ImageLibraryOptions = {
  ...qualityOptions,
  mediaType: 'photo',
  includeBase64: true,
  selectionLimit: 3,
}

export { cameraOptions, libraryOptions, MAX_SIZE, QUALITY }
